<template>
  <div class="date-filter">
    <div class="filter-label">{{ label || '统计时间' }}：</div>
    <div class="filter-list">
      <div
        v-for="item in filterList"
        :key="item.value"
        class="filter-item"
        :class="{ 'is-active': dateFilter === item.value }"
        @click="changeQuickFilter(item)"
      >
        {{ item.label }}
      </div>
    </div>
    <el-date-picker
      v-model="customFilter"
      :size="size"
      class="m-r-20"
      type="daterange"
      range-separator="至"
      start-placeholder="开始日期"
      end-placeholder="结束日期"
      value-format="yyyy-MM-dd HH:mm:ss"
      :default-time="['00:00:00', '23:59:59']"
      @change="pickerChange"
    />
    <!--    <el-button type="primary" @click="confirm">确定</el-button>-->
  </div>
</template>

<script>
import { quickDateDict } from '@/dictionary/date-filter'

export default {
  name: 'DateFilterBar',

  props: {
    defaultFilter: {
      type: [String, Number],
      default: quickDateDict.ONE_YEAR.value
    },

    showAll: {
      type: Boolean,
      default: false
    },

    size: {
      type: String,
      default: 'middle'
    },

    label: {
      type: String,
      default: '统计时间'
    },

    /**
     * 开始时间
     * 默认是自定义模式时使用
     */
    startTime: {
      type: String,
      default: ''
    },

    /**
     * 结束时间
     * 默认是自定义模式时使用
     */
    endTime: {
      type: String,
      default: ''
    }
  },

  data() {
    return {
      dateFilter: quickDateDict.ONE_YEAR.value,
      customFilter: []
    }
  },

  computed: {
    filterList() {
      const tempArr = quickDateDict.array
      tempArr.pop()
      if (!this.showAll) tempArr.shift()
      return tempArr
    }
  },

  created() {
    this.dateFilter = this.defaultFilter
    if (this.defaultFilter === quickDateDict.CUSTOM.value) {
      this.customFilter = [this.startTime || '', this.endTime || '']
    }
  },

  methods: {
    changeQuickFilter(item) {
      this.dateFilter = item.value
      this.customFilter = []
      this.$emit('filterChange', this.dateFilter, item?.dayRange)
    },

    pickerChange() {
      if (this.customFilter?.length > 0) {
        this.dateFilter = quickDateDict.CUSTOM.value
      } else {
        this.dateFilter = quickDateDict.ONE_YEAR.value
        this.$emit(
          'filterChange',
          this.dateFilter,
          quickDateDict.translate(this.dateFilter)?.dayRange
        )
      }
      this.$emit('customFilterChange', this.customFilter)
    }
  }
}
</script>

<style lang="scss" scoped>
.date-filter {
  display: flex;
  align-items: center;

  .filter-label {
    font-size: pixel-to-rem($n: 20);
    color: $second-text-color;
  }

  .filter-list {
    display: flex;
    align-items: center;

    .filter-item {
      padding: 7px 15px;
      border-radius: 4px;
      border: 1px solid $border-color;
      //font-size: pixel-to-rem($n: 16);
      margin-right: pixel-to-rem($n: 10);
      cursor: pointer;
      //color: $third-text-color;
      background-color: $white-color;

      &.is-active {
        color: $white-color;
        background-color: $primary-color;
        border: 1px solid $primary-color;
      }
    }
  }

  ::v-deep .el-range-editor {
    width: pixel-to-rem($n: 320);
    .el-range-separator {
      width: 10%;
    }
    .el-range__close-icon {
      width: 0;
    }
  }
}
</style>
